import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconLiveDotStyle0 = gravityIconIndividualCss;

const GravityIconLiveDot = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'db1ee4976076d436a195cbdf831413e1bd6b2da2', color: this.color, size: this.size }, h("svg", { key: 'bdf9d179d476cda028730781f688b7df51978bc5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '4e148621042520682e7d49c44d9f1b1107e634a1', d: "M7.5 11a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z", fill: "currentColor" }), h("path", { key: 'c3c419717c742e8ec0c84da6486af771649239c2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Z", fill: "currentColor" }))));
    }
};
GravityIconLiveDot.style = GravityIconLiveDotStyle0;

export { GravityIconLiveDot as gravity_icon_live_dot };

//# sourceMappingURL=gravity-icon-live-dot.entry.js.map